import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';

import {ClientUser, ProfileClient, RbAuthResponse, User} from '../shared/interfaces';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {catchError, tap} from 'rxjs/operators';
import {AlertService} from './alert.service';
import {SocialUser, FacebookLoginProvider, GoogleLoginProvider} from 'angularx-social-login';

@Injectable()
export class AuthService {
    constructor(
        private  http: HttpClient,
        private alert: AlertService
    ) {}
   get token(): string{
        const expDate = new Date(localStorage.getItem('rb-token-exp'));
        if(new Date() >expDate){
            this.logout()
            return null;
        }
        return localStorage.getItem('rb-token');
   }
    login(user: User): Observable<any>{

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'text/html, application/xhtml+xml, */*',
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };

        let body= `grant_type=password&client_id=${environment.apiKey}&client_secret=${environment.apiSec}&username=`+user.email+`&password=`+user.password;

        return this.http.post(`${environment.schema}${environment.apiUrl}/oauth/v2/token`, body,httpOptions)
           .pipe(
               tap(this.setToken),
               catchError(this.hendleErrr.bind(this))

           )
    }

    private hendleErrr(error:HttpErrorResponse){
        const message = error.error.error_description
        switch (message){
            case 'Invalid username and password combination':
                this.alert.danger( 'Invalid username and password combination')
                break

        }
        console.log(message)

        return throwError(error)
    }
    registr(clientuser: ClientUser): Observable<any>{

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'text/html, application/xhtml+xml, */*',
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };


        return this.http.post(`${environment.schema}${environment.apiUrl}/registration/`, clientuser,httpOptions)
            .pipe(
                tap(this.setToken)
            )
    }

    logout(){
        this.setToken(null);
    }
    isAutheniticate():boolean{

        return !!this.token;
    }

        private setToken(response: RbAuthResponse|null){
        if(response){
            const expDate = new Date(new Date().getTime() + +response.expires_in*1000)
            localStorage.setItem('rb-token',response.access_token)
            localStorage.setItem('rb-token-exp',expDate.toString())
        }else{
            localStorage.clear()
        }
        }




    public setUser(client: ProfileClient|null){
        console.log('client',client);
        if(client){
           localStorage.setItem('rb-name', client.name)
           localStorage.setItem('rb-peer', client.id)
           localStorage.setItem('rb-avatar', client.client_avatar)
        }
    }

    soclogin(user: SocialUser): Observable<any>{

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'text/html, application/xhtml+xml, */*',
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };

        let body='';
        if(user.provider == FacebookLoginProvider.PROVIDER_ID){

            body= `grant_type=${environment.schema}${environment.apiUrl}&client_id=${environment.apiKeyF}&client_secret=${environment.apiSecF}&provider=fb&number_2=66&username=`+user.email+"&access_token="+user.authToken;

        }else{
            body= `grant_type=${environment.schema}${environment.apiUrl}&client_id=${environment.apiKeyG}&client_secret=${environment.apiSecG}&provider=g&number_2=66&username=`+user.email+"&access_token="+user.idToken;

        }
        const tuser: RbAuthResponse ={
            access_token: user.idToken,
            expires_in: user.response.expires_in,
            refresh_token: user.idToken,
            scope: '',
            token_type: 'string',
        }
        console.log('ok:', user);
        this.setToken(tuser);
        return this.http.post(`${environment.schema}${environment.apiUrl}:9443/auth/google/token?access_token=${user.idToken}`, body ,httpOptions)
            .pipe(
                tap(this.setUser),
                catchError(this.hendleErrr.bind(this))
            )
    }


}
